import './styles.css'
import { applySauce, currentSauce } from './sauces'
import { installCommandPalette } from './palette'
import { startRouter } from './router'
import { currentUser } from './session'
import { editorView } from './views/editor'
import { listView } from './views/list'
import { notFoundView } from './views/notfound'
import { passkeysView } from './views/passkeys'
import { pasteView } from './views/view'
import { signInView } from './views/signin'
import { tokensView } from './views/tokens'

const ID = '[23456789abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ]{4,32}'
const VIEW_PATH = new RegExp(`^/p/(${ID})$`)
const EDIT_PATH = new RegExp(`^/e/(${ID})$`)

function mountPoint(): HTMLElement {
  const element = document.querySelector<HTMLElement>('#app')
  if (!element) throw new Error('#app is missing from the document')
  return element
}

const app = mountPoint()

applySauce(currentSauce())
installCommandPalette()

let dispose: (() => void) | null = null
let generation = 0

startRouter((path) => {
  void dispatch(path)
})

async function dispatch(path: string): Promise<void> {
  const mine = ++generation
  const user = await currentUser()
  // The user navigated again while /api/me was in flight.
  if (mine !== generation) return

  dispose?.()
  dispose = null
  app.replaceChildren()

  const viewMatch = VIEW_PATH.exec(path)
  if (viewMatch?.[1]) {
    dispose = pasteView(app, viewMatch[1], user)
    return
  }

  // Everything below needs an account.
  if (!user) {
    dispose = signInView(app, { next: path })
    return
  }

  if (path === '/') {
    dispose = editorView(app, { user })
    return
  }

  const editMatch = EDIT_PATH.exec(path)
  if (editMatch?.[1]) {
    dispose = editorView(app, { user, id: editMatch[1] })
    return
  }

  if (path === '/mine') {
    dispose = listView(app, user)
    return
  }

  if (path === '/tokens') {
    dispose = tokensView(app, user)
    return
  }

  if (path === '/passkeys') {
    dispose = passkeysView(app, user)
    return
  }

  dispose = notFoundView(app, user)
}
